/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import IconButton from '@material-ui/core/IconButton';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Carousel from 'react-elastic-carousel';
import isNil from 'lodash/isNil';
import ADGMImage from '../ADGMImage';
import ADGMResponsiveModal from '../ADGMResponsiveModal';
import './stlyes.css';
import styles from './styles';

const breakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 550, itemsToShow: 1, itemsToScroll: 1 },
  { width: 768, itemsToShow: 1 },
  { width: 1200, itemsToShow: 1 },
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom direction='up' ref={ref} {...props} />;
});

function ADGMGallery(props) {
  const { classes, open, title, images, toggleModal, handleCloseModal } = props;
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  return (
    <ADGMResponsiveModal
      open={open}
      toggleModal={toggleModal}
      onClose={handleCloseModal}
      title={title}
      customClasses={{ content: classes.galleryModalBody }}
    >
      <div className={classes.caroselWrapper}>
        <Carousel breakPoints={breakPoints}>
          {images?.map((item, index) => (
            <div key={`${item}-${index}`} className={classes.corouselImgContainer}>
              <ADGMImage httpURL={item} alt='gallery' />
              <IconButton
                aria-label='full-screen'
                onClick={() => setSelectedImageIndex(index)}
                className={classes.fullScreenIcon}
              >
                <FullscreenIcon className={classes.icon} />
              </IconButton>
            </div>
          ))}
        </Carousel>
      </div>
      <Dialog
        fullScreen
        disableScrollLock
        open={!isNil(selectedImageIndex)}
        onClose={() => setSelectedImageIndex(null)}
        TransitionComponent={Transition}
        classes={{ root: classes.fullScreenDialog, paper: classes.fullScreenPaper }}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge='start' color='inherit' onClick={() => setSelectedImageIndex(null)} aria-label='close'>
              <CloseIcon />
            </IconButton>
            <Typography variant='h6' className={classes.title}>
              {title}
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.dialogImageContainer}>
          <ADGMImage httpURL={images[selectedImageIndex]} alt='selected' className={classes.dialogImage} />
          <IconButton
            aria-label='full-screen'
            onClick={() => setSelectedImageIndex(null)}
            className={classes.fullScreenIcon}
          >
            <FullscreenExitIcon className={classes.icon} />
          </IconButton>
        </div>
      </Dialog>
    </ADGMResponsiveModal>
  );
}

ADGMGallery.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  images: PropTypes.array.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

ADGMGallery.defaultProps = {
  open: false,
};

export default withStyles(styles)(ADGMGallery);
